import React from 'react'
import { clerksElement } from './myFunctions';
import { v4 as uuidv4 } from 'uuid'; 
import MonthlyMeetingList from './MonthlyMeetingList';
export default function QuarterlyMeeting({oym,quarterlyMeeting,dropBreadcrumb,authenticated}) {
    console.log("QM authenticated "+authenticated);
    let quarterlyMeetingObject=oym.objectRef(quarterlyMeeting);
    let clerkObject=oym.objectRef(quarterlyMeetingObject.clerk);
    console.log(quarterlyMeetingObject);
    // console.log(quarterlyMeetingObject,quarterlyMeetingObject.montlyMeetings[1]);
    return (
        <div>
            <br/>
            {quarterlyMeetingObject.name}<br/>
            {clerksElement(quarterlyMeetingObject,oym,dropBreadcrumb,authenticated)}<br/>
            <MonthlyMeetingList  key={uuidv4()} list={quarterlyMeetingObject.montlyMeetings[1]} oym={oym} dropBreadcrumb={dropBreadcrumb} authenticated={authenticated}/>
        </div>
    )
}
